import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Templates, Template, Categorie, TemplateCreateHtml, TemplateCreateFile } from '../models/email/template';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getTemplates(type?, category?): Observable<Templates> {
    let params = new HttpParams();
    if (type) {
      params = params.append('type', type);
    }
    if (category) {
      params = params.append('category', category);
    }
    return this.http
      .get<Response>(this.baseUrl + 'email/template', { params })
      .pipe(
        map(data => {
          return Template.deserialize({
            data: (data ? ((data as unknown) as Array<string>) : []).map(data2 => Template.deserialize(data2))
          });
        })
      );
  }

  getTemplate(idTemplate): Observable<Template> {
    return this.http.get<Response>(this.baseUrl + 'email/template/' + idTemplate).pipe(map(data => Template.deserialize(data)));
  }

  getCategories(): Observable<any> {
    return this.http.get<Response>(this.baseUrl + 'email/template/category', {}).pipe(
      map(data => {
        return Categorie.deserialize({
          data: (data ? ((data as unknown) as Array<string>) : []).map(data2 => Categorie.deserialize(data2))
        });
      })
    );
  }

  createTemplateHtml(templateCreateHtml: TemplateCreateHtml) {
    return this.http.post(this.baseUrl + 'email/template', templateCreateHtml).pipe(map(data => Template.deserialize(data)));
  }

  createTemplateFile(templateCreateFile: TemplateCreateFile) {
    const formData = new FormData();
    formData.append('file', templateCreateFile.file);
    formData.append('name', templateCreateFile.name);
    return this.http.post(this.baseUrl + 'email/template/import-from-file', formData).pipe(map(data => Template.deserialize(data)));
  }

  deleteTemplate(template: Template) {
    return this.http.delete(this.baseUrl + 'email/template/' + template.idTemplate, { responseType: 'text' as 'json' });
  }
}
